import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Table } from "react-bootstrap";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import axios from "../axios/axios";

import moment from "moment";
import { Link } from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute";

export default function MesCandidature() {
  const token = Cookies.get("auth_token");
  const currentDate = moment().format("YYYY-MM-DD HH:mm:ss");
  const [candidatures, setCandidatures] = useState([]);
  const [cv, setCv] = useState({});
  const [chargement, setChargement] = useState(false);

  useEffect(() => {
    mesCandidatures();
  }, []);

  const mesCandidatures = () => {
    setChargement(true);
    axios
      .get("/mesCandidatures", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setCandidatures(response.data.candidatures);
        setCv(response.data.cv);
        setChargement(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  if (candidatures.length == 0)
    return (
      <center>
        <p>Pas de candidatures disponibles...</p>
      </center>
    );
  return chargement == true ? (
    <div className="container card text-center mt-5">
      <h4>Chargement .... </h4>
    </div>
  ) : (
    <ProtectedRoute>
      <div className="container card mt-4 mb-4 p-2">
        <p style={{ fontWeight: "bold", fontSize: 20 }}> Mes Candidatures </p>
        <div style={{ borderTop: "3px solid #eee" }}>
          <br />
        </div>

        <Table striped bordered hover responsive="sm">
          <thead>
            <tr>
              <th>Date de candidature</th>
              <th>Offre d’emploi</th>
              <th>Societe</th>
              <th>Modifier</th>
            </tr>
          </thead>
          <tbody>
            {candidatures.map((candidature, index) => (
              <tr key={index}>
                <td>{moment(candidature.created_at).format("DD/MM/YYYY")}</td>
                <td>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: candidature.offer_emploie.libelle,
                    }}
                  ></span>
                </td>
                <td>{candidature.offer_emploie.societe.nom}</td>
                <td>
                  {candidature.offer_emploie.fin > currentDate ? (
                    <Link
                      to={`${process.env.PUBLIC_URL}/modifier-cv/${candidature.cv_id}`}
                    >
                      <FontAwesomeIcon
                        icon={faEdit}
                        className="text-success fa-lg"
                      />
                    </Link>
                  ) : null}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </ProtectedRoute>
  );
}
